import { createContext } from 'react';
const TranslationsContext = createContext({
    familyKey: undefined,
});
export default TranslationsContext;
//# sourceMappingURL=TranslationsContext.js.map